import client from 'providers/backend'

export const getUser = () => client.get('/me')

export const login = data => client.post('/login', data)

export const register = data => client.post('/users', data)
